import { NgModule } from '@angular/core';
import { InviteNewUserComponent } from './invite-new-user.component';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';
import { MatStepperCustomModule } from '@shared/mat-stepper-custom/mat-stepper-custom.module';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [InviteNewUserComponent],
  imports: [
    MatDialogCustomModule,
    MatStepperCustomModule,
    MatInputModule,
    SharedModule,
  ],
  exports: [InviteNewUserComponent],
})
export class InviteNewUserModule {}
